//PowerToggle.tsx — the single primary action: one button that starts and stops the session

import { PlayIcon, StopIcon } from './icons'

interface Props {
	live: boolean
	busy: boolean
	disabled: boolean
	onToggle: () => void
	//Wide renders the glyph beside a label, for use as the leading action in a panel where a
	//bare circle would read as just another row.
	wide?: boolean
	subject?: string
}

export function PowerToggle({ live, busy, disabled, onToggle, wide = false, subject = 'try-on' }: Props) {
	const label = busy ? 'Connecting…' : live ? `Stop ${subject}` : `Start ${subject}`

	return (
		<button
			type="button"
			className={`toggle ${wide ? 'is-wide' : ''} ${live ? 'is-live' : ''} ${
				busy ? 'is-busy' : ''
			}`}
			onClick={onToggle}
			disabled={disabled || busy}
			aria-label={label}
			aria-pressed={live}
			title={disabled && !live ? 'Pick a garment first' : label}
		>
			<span className="toggle-glyph">{live ? <StopIcon /> : <PlayIcon />}</span>
			{wide && <span className="toggle-label">{label}</span>}
		</button>
	)
}
